export default __webpack_public_path__ + "static/media/(62).97a31a4b.jpg";